import { render } from "./updateCharge.vue?vue&type=template&id=e1ed442c&scoped=true"
import script from "./updateCharge.vue?vue&type=script&lang=js"
export * from "./updateCharge.vue?vue&type=script&lang=js"

import "./updateCharge.vue?vue&type=style&index=0&id=e1ed442c&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ed442c"]])

export default __exports__